module.exports = __webpack_public_path__ + "img/399.b8f7b276.jpg";